import { useLocalSearchParams } from 'expo-router'

import { FraternityPresentationScreen } from '@/src/features/fraternity/ui/screens/FraternityPresentationScreen'
import { filterSearchParams } from '@/src/general/utils/filterSearchParams'

const CommunityJoinPresentationRouterPage = () => {
  const searchParams = useLocalSearchParams()
  const { idSlug } = filterSearchParams<TIdSlugParam>(searchParams)

  if (!idSlug) return null

  return <FraternityPresentationScreen idSlug={idSlug} searchParams={searchParams} />
}

export default CommunityJoinPresentationRouterPage
